import React from "react";

type SearchHitsContentProps = {
  title?: string,
  description?: string,
  items?: any,
  id?: string
};

const SearchHitsContent = (props: SearchHitsContentProps): JSX.Element => {
  const {
    title,
    description,
    items,
    id
  } = props;

  return (
    <div className="sa-search-hits">
      <div className="sa-search-hits-anchor" id={id}></div>

      <h2>{title}</h2>
      <p className="body-1">{description}</p>

      <div className="sa-search-hits-content">
        {items && items.map((tool: any, i: number) => {
          return (
            <a key={i} className="maincard maincard-article" href={tool.url}>
              <div className="maincard-image">
                <img src={tool.image_url} alt={tool.image_caption} />
                {tool.new_icon &&
                  <div className="maincard-new">NY</div>
                }
                <div className="maincard-article-label">
                <span className="body-3 bold">{tool.primary_tag}</span>
                </div>
              </div>
              <div className="maincard-content content-is-article">
                <div>
                  <h3 className="h4">{tool.title}</h3>
                </div>
                <p>{tool.content_short}</p>
                {tool.format_tag &&
                  <div className="maincard-article-meta content-filtering-meta">
                    {tool.format_tag.map((tag: string, i: number) => {
                      return (
                        <>
                          <p className="body-3"><b>{tag}</b></p>
                          <div className="divider"></div>
                        </>
                      )
                    })}
                  </div>
                }
              </div>
            </a>
            )
          })}
        </div>
      </div>  
  );
};

export default React.memo(SearchHitsContent);
